import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@Types/index';
import { getDefaultUserState } from '@Store/utils/getDefaultUserState';

type UserState = {
  user: User;
  createdUserRequest: User;
  selectedUser: User;
  userCollection: Map<string, User>;
};

const initialState: UserState = {
  user: getDefaultUserState(),
  createdUserRequest: getDefaultUserState(),
  selectedUser: getDefaultUserState(),
  userCollection: new Map<string, User>(),
};

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUser: (state: UserState, action: PayloadAction<User>) => {
      const defaultUserState = getDefaultUserState();

      state.user = {
        ...defaultUserState,
        ...action.payload,
      };
    },
    setCreatedUserRequest: (state: UserState, action: PayloadAction<User>) => {
      const defaultUserState = getDefaultUserState();

      state.createdUserRequest = {
        ...defaultUserState,
        ...action.payload,
      };
    },
    setSelectedUser: (state: UserState, action: PayloadAction<User | null>) => {
      const { payload } = action;
      const defaultUserState = getDefaultUserState();

      if (payload === null) {
        state.selectedUser = defaultUserState;
      } else {
        state.selectedUser = {
          ...defaultUserState,
          ...payload,
        };
      }
    },
    addUserCollection: (
      state: UserState,
      action: PayloadAction<Map<string, User>>
    ) => {
      state.userCollection = action.payload;
    },
  },
});

const { actions } = userInfoSlice;

export const userInfoActions = {
  ...actions,
};

export default userInfoSlice;
